module.exports = __webpack_public_path__ + "img/bottom.9bc17f45.png";